import { observer } from 'mobx-react';
import { FC } from 'react';
import ApplePayInput from '../../components/ApplePayInput/ApplePayInput';
import { IApplePaySettings } from '../../types/applePay';
import ApplePayDomains from '../ApplePayDomains/ApplePayDomains';
import applePaySettingsStore from '../../store/applePaySettingsStore';
import { BUTTON_TITLE } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import { booleanToNumber } from '~/utils/helpers';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';
import { TBooleanInNumber } from '~/types/main';

interface IPropsApplePaySettings {
  settings: IApplePaySettings;
}

const ApplePaySettings: FC<IPropsApplePaySettings> = ({ settings }: IPropsApplePaySettings): JSX.Element => {
  const handleSave = () => {
    applePaySettingsStore.update();
  };

  const handleSwitcherClick = (field: keyof IApplePaySettings) => (enabled: TBooleanInNumber) => {
    applePaySettingsStore.changeSettingHandler({ [field]: Boolean(enabled) });
  };

  const handleInputChange = (field: keyof IApplePaySettings) => (displayName: string | undefined) => {
    applePaySettingsStore.changeSettingHandler({ [field]: displayName ?? '' });
  };

  return (
    <div className="d-flex flex-column">
      <div className="d-flex align-items-center">
        <Switcher status={booleanToNumber(settings.enabled)} onChange={handleSwitcherClick('enabled')} />
        <Text type={TEXT.SWITCHER_LABEL} text={localeStore.t('enable')} className="family-semibold" />
      </div>

      <div className="d-flex flex-row gap-30">
        <ApplePayInput title="apple_pay_display_name" value={settings.displayName} onChange={handleInputChange('displayName')} />
      </div>

      <ApplePayDomains domains={settings.domains} />

      <Button title={localeStore.t(BUTTON_TITLE.SAVE)} loading={applePaySettingsStore.isLoading} onClick={handleSave} className="mt-8" />
    </div>
  );
};

export default observer(ApplePaySettings);
